/* eslint-disable no-unreachable */
/* eslint-disable no-useless-return */

import gsap from 'gsap';
import Sniffer from 'sniffer';

export default class Menu {
  constructor() {
    this.el = document.querySelector('.a-menu');

    this.ww = window.innerWidth;

    this.logo = document.querySelector('.a-logo');
    this.main = document.querySelector('.a-main');
    this.open = document.querySelector('.a-menu-open');
    this.src = document.querySelectorAll('.a-menu-src');
    this.items = document.querySelector('.a-menu-items');
    this.item = document.querySelectorAll('.a-menu-item');
    this.close = document.querySelector('.a-menu-close');
    this.mask = document.querySelectorAll('.a-menu-mask');
    this.bottom = document.querySelector('.a-menu-bottom');
    this.images = document.querySelector('.a-menu-images');
    this.image = document.querySelectorAll('.a-menu-image');
    this.titles = document.querySelectorAll('.a-menu-title');
    this.container = document.querySelector('.a-menu-container');
    this.indicators = document.querySelectorAll('.a-menu-indicator');

    this.transition = {
      el: undefined,
      img: undefined,
    };

    this.ww = window.innerWidth;
    this.wh = window.innerHeight;

    this.state = {
      active: false,
      reverse: false,
      animating: false,
    };
  }

  reset = () => {
    if (this.transition.el) {
      this.transition.el.remove();
    }
    this.state.animating = false;
    this.setMenu();
  }

  openState = () => {
    this.state.active = true;
    this.items.style.pointerEvents = 'all';
    this.close.style.pointerEvents = 'all';
    this.open.style.pointerEvents = 'none';
  }

  closeState = () => {
    this.state.active = false;
    this.open.style.pointerEvents = 'all';
    this.items.style.pointerEvents = 'none';
    this.close.style.pointerEvents = 'none';
  }

  openMenu = () => {
    this.state.reverse = false;

    this.openState();

    const eb = this.image[0].querySelector('img').getBoundingClientRect();

    const w = (eb.width / window.innerWidth) * window.innerWidth;
    const h = (eb.width / window.innerWidth) * window.innerHeight;

    gsap.set(this.src, {
      width: w,
      height: h,
    });

    const tl = gsap.timeline({
      defaults: {
        duration: 1.5,
        ease: 'expo.inOut',
      },
    });

    tl
      .to(this.main, {
        y: -this.wh / 2,
      }, 0)

      .to(this.close, {
        y: 0,
        opacity: 1,
      }, 0)

      .to(this.open, {
        opacity: 0,
        y: -this.open.clientHeight,
      }, 0)

      .to(this.container, {
        y: 0,
      }, 0);
  }

  closeMenu = () => {
    if (this.state.active === false) return;

    this.closeState();

    let y = this.wh;

    if (this.state.reverse === true) {
      this.state.reverse = false;
      y = -this.wh / 2;
    }

    const tl = gsap.timeline({
      defaults: {
        duration: 1.5,
        ease: 'expo.inOut',
        onComplete: this.reset,
      },
    });

    tl
      .to(this.main, {
        y: 0,
      }, 0)

      .to(this.close, {
        opacity: 0,
        y: -this.open.clientHeight,
      }, 0)

      .to(this.open, {
        y: 0,
        opacity: 1,
      }, 0)

      .to(this.container, {
        y,
      }, 0);
  }

  setMenu = () => {
    if (this.state.animating === true) return;

    this.ww = window.innerWidth;
    this.wh = window.innerHeight;

    if (this.state.active === false) {
      gsap.set(this.container, {
        y: this.wh,
      });

      gsap.set(this.close, {
        opacity: 0,
        y: this.close.clientHeight,
      }, 0);
    }

    if (Sniffer.isPhone) {
      this.images.remove(); return;
    }

    gsap.set(this.mask, {
      y: -Math.round(this.ww * 0.093),
      width: Math.round(this.ww * 0.185),
      height: Math.round(this.ww * 0.147),
    });

    gsap.set(this.mask[0], {
      x: 0,
    });

    gsap.set(this.mask[1], {
      x: Math.round(this.ww * 0.234),
    });

    gsap.set(this.mask[2], {
      x: Math.round(this.ww * 0.468),
    });

    gsap.set(this.mask[3], {
      x: Math.round(this.ww * 0.703),
    });

    gsap.set(this.image, {
      opacity: 0.1,
    });
  }

  loadPage = (el, i) => {
    this.closeState();

    this.mask[i].style.zIndex = 2;

    window.scrollTo(0, 0);

    if (!Sniffer.isPhone) {
      this.transition.el = document.createElement('div');
      this.transition.el.classList.add('a-menu-transition');

      this.container.appendChild(this.transition.el);

      this.transition.img = document.createElement('img');
      this.transition.img.classList.add('a-menu-zoom');
      this.transition.img.src = this.image[i].querySelector('.a-menu-src').src;
      this.transition.img.style.visibility = 'hidden';

      this.transition.el.appendChild(this.transition.img);

      this.sb = this.transition.img.getBoundingClientRect();
      this.mb = this.image[i].closest('.a-menu-mask').getBoundingClientRect();
      this.eb = this.image[i].querySelector('img').getBoundingClientRect();

      gsap.set(this.transition.img, { scale: this.eb.width / this.sb.width });

      this.tx = (this.sb.width / (this.sb.width - this.eb.width)) * (this.eb.left - (0 * this.eb.width) / this.sb.width);
      this.ty = (this.sb.height / (this.sb.height - this.eb.height)) * (this.eb.top - (0 * this.eb.height) / this.sb.height);

      this.transition.img.style.transformOrigin = `${this.tx}px ${this.ty}px`;
      this.transition.img.style.visibility = 'inherit';

      gsap.set(this.transition.el, {
        clip: `rect(${this.mb.top}px ${this.mb.left + this.mb.width}px ${this.mb.bottom}px ${this.mb.left}px)`,
      });

      gsap.to(this.transition.el, {
        delay: 0.1,
        duration: 1.5,
        autoRound: false,
        ease: 'expo.inOut',
        clip: `rect(0px ${window.innerWidth}px ${window.innerHeight}px 0px)`,
      });

      gsap.to(this.transition.img, {
        scale: 1,
        duration: 1.5,
        autoRound: false,
        ease: 'expo.inOut',
        onComplete: this.reset,
      });
    }

    const tl = gsap.timeline({
      defaults: {
        duration: 1.5,
        autoRound: false,
        ease: 'expo.inOut',
      },
    });

    tl
      .set(this.main, {
        clearProps: 'all',
      }, 0)

      .set(this.open, {
        opacity: 0,
        y: -this.open.clientHeight,
      }, 0)

      .to(this.open, {
        y: 0,
        opacity: 1,
      }, 0)

      .to(this.close, {
        opacity: 0,
        y: this.close.clientHeight,
      }, 0)

      .to(this.titles, {
        opacity: 0,
        clearProps: 'all',
        y: 50,
      }, 0)

      .to(this.bottom, {
        clearProps: 'all',
        y: window.innerHeight,
      }, 0);

    if (Sniffer.isPhone) {
      tl
        .to(this.container, {
          y: window.innerHeight,
        }, 0.5);
    }

    if (Sniffer.isPhone) return;

    tl
      .to(this.indicators, {
        scaleX: 0,
        opacity: 0,
        transformOrigin: 'right',
        clearProps: 'transform-origin,opacity',
      }, 0);
  }

  mouseEnter = (i) => {
    const tl = gsap.timeline({
      defaults: {
        duration: 0.5,
      },
    });

    tl
      .to(this.indicators[i], {
        scaleX: 1,
      }, 0)

      .to(this.image[i], {
        opacity: 1,
        // scale: 1.2,
      }, 0);
  }

  mouseLeave = () => {
    if (this.state.animating === true) return;

    const tl = gsap.timeline({
      defaults: {
        duration: 0.5,
      },
    });

    tl
      .to(this.indicators, {
        scaleX: 0,
      }, 0)

      .to(this.image, {
        // scale: 1,
        opacity: 0.1,
      }, 0);
  }

  addEvents = () => {
    window.addEventListener('resize', this.setMenu);
    window.addEventListener('popstate', () => {
      this.state.reverse = true;
      this.closeMenu();
    });

    this.open.addEventListener('click', this.openMenu);
    this.close.addEventListener('click', this.closeMenu);

    this.logo.addEventListener('click', () => {
      this.state.reverse = true;
      this.closeMenu();
    });

    [...this.item].forEach((el, i) => {
      el.addEventListener('click', () => {
        this.state.animating = true;
        this.loadPage(el, i);
      });
      el.addEventListener('mouseenter', () => {
        if (Sniffer.isPhone) return;
        this.mouseEnter(i);
      });
      el.addEventListener('mouseleave', () => {
        if (Sniffer.isPhone) return;
        this.mouseLeave();
      });
    });
  }

  init = () => {
    this.setMenu();
    this.addEvents();
  }
}
